export class CookieBanner {
    constructor(banner) {
        var _a;
        this.cookieName = 'ccpaaccept';
        this.cookieExpirationDays = 30;
        this.setCookie = () => {
            const now = new Date();
            const time = now.getTime();
            const expireTime = time + (this.cookieExpirationDays * 24 * 60 * 60 * 1000);
            now.setTime(expireTime);
            document.cookie = `${this.cookieName}=true;expires=${now.toUTCString()};path=/`;
        };
        this.onAcceptCookie = (e) => {
            e.preventDefault();
            this._banner.classList.remove(this.cookieName);
            this.setCookie();
        };
        this._banner = banner;
        if (this._banner && !this.cookie) {
            (_a = this._banner.querySelector('.banner__cta .btn-primary-d')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', this.onAcceptCookie);
            this._banner.classList.add(this.cookieName);
        }
    }
    get cookie() {
        var _a, _b;
        return (_b = (_a = RegExp(`(^|;)\\s*${this.cookieName}\\s*=\\s*([^;]+)`).exec(document.cookie)) === null || _a === void 0 ? void 0 : _a.pop()) !== null && _b !== void 0 ? _b : null;
    }
}
